import React, { useContext } from "react";
import listContext from "../list_context";
import { RemoveButton } from "./removeButton";
import { SimpleImg } from 'react-simple-img';

export const Cart = () => {
  const { cart, cartTotal } = useContext(listContext);
  console.log("cart" + cartTotal, useContext(listContext));
  const cartlist = cart.map((i, index) => {
    return (
      <>
        <ul className="cart-wrapper" key={index}>
          <li>
            <div className="cart-img">
            <SimpleImg height={48} src={i.img} alt={ i.name } placeholder="#ffffff" style={{padding: 10}} />
              {i.name}
            </div>
            <div className="cart-name">
              {i.name}
              <small>$ {i.price} x {i.count}</small>
            </div>
            <div className="cart-price">$ {i.price * i.count}</div>
            <div className="cart-price">{<RemoveButton pd={i} />}</div>
          </li>
        </ul>
      </>
    );
  });

  if (cart.length > 0) {
    return (
      <div className="main custom-scroll">
        <h1>Cart</h1>
        {cartlist}
        <div>
          <ul className="cart-wrapper">
            <li className="total-price">
              <div>Total Price: $ {cartTotal}</div>
            </li>
          </ul>
        </div>
        <button className="sticky-cart-btn">CheckOut</button>
      </div>
    );
  } else {
    return (
      <div className="main custom-scroll">
        <div className="empty-cart">
          <SimpleImg height={197} src="https://www.elifeamerica.com/ecommerce-app/empty-cart.png" alt="Cart Empty" placeholder="#ffffff" />
          <h1>Your cart is empty</h1>
          <p className="c">Looks like you don’t have made your choice yet.</p>
        </div>
      </div>
    );
  }
};
